import { Grid, Row, Col } from "react-flexbox-grid";
import { HeaderDashboard } from "components";
import { useWindowSize } from "hooks";

import styled from "styled-components";

const PaperShaped = styled(Row)`
  background: white;
  border-radius: ${({ borderradius }) => borderradius};
  padding: ${({ padding }) => padding};
  margin: 0;
`;

export const PageWrapper = ({ children, header, isBack }) => {
  const { width } = useWindowSize();
  const isMobile = width <= 425;

  return (
    <Grid fluid className="p0 min-vh-90">
      <Row className="m0">
        <Col
          xs={12}
          className="p0 bg-black"
          data-aos="fade-zoom-in"
          data-aos-easing="ease-in-back"
          data-aos-delay="50"
          data-aos-offset="0"
        >
          <HeaderDashboard isBack={isBack}>{header}</HeaderDashboard>
          <PaperShaped
            borderradius={isMobile ? "3em 3em 0 0" : "8em 8em 0 0"}
            padding={isMobile ? "4em 1em 0" : "4em 2em"}
          >
            {children}
          </PaperShaped>
        </Col>
      </Row>
    </Grid>
  );
};
